import React, { useEffect, useState } from "react";
import {
  FaTrash,
  FaInfoCircle,
  FaUpload,
  FaCalculator,
  FaShieldAlt,
} from "react-icons/fa";
import { FiShield } from "react-icons/fi";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import "./UpdateBidView.scss";
import { hitUploadMedia } from "../../../Redux/Common/UploadMediaSlice";
import { hitUpdateBidProfessionalApi } from "../../../Redux/Professional/BidUpdateProfessionalSlice";
import { useNavigate } from "react-router-dom";
import { hitGetBoostBidProfessionalApi } from "../../../Redux/Professional/GetBoostBidsSlice";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { FaStar, FaCheckCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { timeAgo } from "../../../Helper/CommonFunctions";
import { all } from "axios";
import BoostYourBid from "../../../assets/img/Boost Your Bid.svg";
import boostBtn from "../../../assets/img/Boost btn.svg";

import Loader from "../../Loader/Loader"; // adjust the path

const UpdateBidView = ({ jobData }) => {
  //console.log("jobData in UpdateBidView", jobData);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [bid, setBid] = useState(1);
  const [boostBidPoints, setBoostBidPoints] = useState(0);
  const [credits, setCredits] = useState(75);
  const [wantToBoostBid, setWantToBoostBid] = useState(false);
  const [boostBidsData, setBoostBidsData] = useState([]);
  const [finalMediaToSend, setFinalMediaToSend] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [tax, setTax] = useState(0);

  const [loading, setLoading] = useState(false);

  const [discount1, setDiscount1] = useState(0);
  const [tax1, setTax1] = useState(0);

  const [discount2, setDiscount2] = useState(0);
  const [tax2, setTax2] = useState(0);

  const [customerMessage, setCustomerMessage] = useState("");
  const [requiredDeposit, setRequiredDeposit] = useState(0);
  const [bidExpiry, setBidExpiry] = useState("");
  const [financing, setFinancing] = useState(0);
  const [priceType, setPriceType] = useState(
    jobData
      ? jobData.bidData?.priceType == 1
        ? "guaranteed"
        : "estimated"
      : "guaranteed"
  );
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [isDisabled, setIsDisabled] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [deletedIndexes, setDeletedIndexes] = useState([]);

  const [images, setImages] = useState([
    "https://simplerenovate.s3.us-east-1.amazonaws.com/1763563807127IMG_20251119_201937.jpg",
    "https://simplerenovate.s3.us-east-1.amazonaws.com/1756185746134promo_image_0.jpeg",
    "https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400",
  ]);

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
    } else {
      // dispatch(hitGetBoostBidProfessionalApi(jobData._id));
    }
  }, []);

  const [lineItems, setLineItems] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  const [lineItems1, setLineItems1] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  const [lineItems2, setLineItems2] = useState([
    {
      id: 1,
      product: "",
      description: "",
      quantity: 1,
      unitPrice: 0,
      price: 0,
    },
  ]);

  useEffect(() => {
    //console.log("jobData changed", jobData.bidData);
    if (jobData) {
      const allOptions = jobData.bidData.options;
      //  //console.log("allOptions", allOptions.length);
      if (allOptions && allOptions.length > 0) {
        const option1 = allOptions.find((option) => option.optionType == 1);
        if (option1) {
          const itemsWithId = option1.items.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          ////console.log("itemsWithId", itemsWithId);
          setLineItems(itemsWithId);
          setDiscount(option1.discountPercentage || 0);
        }
        const option2 = allOptions.find((option) => option.optionType == 2);
        if (option2) {
          const itemsWithId = option2.items.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          setLineItems1(itemsWithId);
          setDiscount1(option2.discountPercentage || 0);
        }
        const option3 = allOptions.find((option) => option.optionType == 3);
        if (option3) {
          const itemsWithId = option3.items.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          setLineItems2(itemsWithId);
          setDiscount2(option3.discountPercentage || 0);
        }

        setCustomerMessage(jobData.bidData.message);
        setRequiredDeposit(jobData.bidData.requiredDeposit);
        setBidExpiry(jobData.bidData.expireAt);
        setFinancing(jobData.bidData.financing);
        setFinalMediaToSend(jobData.bidData.media || []);
        setUploadedFiles([]); // Reset uploaded files
      }
    }
  }, [jobData]);

  const handleBoostBid = () => {
    //console.log("handleBoostBid calling", bid);
    setWantToBoostBid(true);
    setBoostBidPoints(bid);
    const newBoostDataArray = [...boostBidsData]; // create a shallow copy
    // Remove any object with createdAt == 1
    const filteredData = newBoostDataArray.filter(
      (item) => item.createdAt !== 1
    );
    filteredData.push({ amount: bid, createdAt: 1, rank: 1 });
    //console.log("After Push boostBidsData", filteredData);
    const newDataSorted = filteredData.sort((a, b) => b.amount - a.amount);
    //console.log("After Sort newDataSorted", newDataSorted);
    // Update the ranks of each place
    // Update ranks by creating new objects with the new rank
    const updatedDataWithRanks = newDataSorted.map((entry, index) => ({
      ...entry, // Spread the old data
      rank: index + 1, // Update the rank
    }));
    //console.log("After Rank newDataSorted", updatedDataWithRanks);
    setBoostBidsData(updatedDataWithRanks);
  };

  const handleRemoveBoostBid = (index) => {
    //console.log("removeBoostBid calling");
    setWantToBoostBid(false);
    setBid(0);
    setBoostBidPoints(0);
    const newBoostDataArray = [...boostBidsData]; // create a shallow copy
    newBoostDataArray.splice(index, 1); // remove the item at the specified index
    //console.log("After Splice newBoostDataArray", newBoostDataArray);
    const newDataSorted = newBoostDataArray.sort((a, b) => b.amount - a.amount);
    //console.log("After Sort newDataSorted", newDataSorted);
    // Update the ranks of each place
    const updatedDataWithRanks = newDataSorted.map((entry, index) => ({
      ...entry, // Spread the old data
      rank: index + 1, // Update the rank
    }));
    //console.log("After Rank newDataSorted", updatedDataWithRanks);
    setBoostBidsData(updatedDataWithRanks);
    if (updatedDataWithRanks.length > 0) {
      setBid(updatedDataWithRanks[0].amount + 1);
    } else {
      setBid(1);
    }
  };

  const handleIncrease = () => {
    setBid(bid + 1);
  };

  const handleDecrease = () => {
    if (bid > 0) {
      setBid(bid - 1);
    }
  };

  // Calculate totals
  const calculateSubTotal = () => {
    return lineItems.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal = calculateSubTotal();
  const discountAmount = (subTotal * discount) / 100;
  const finalTotal = subTotal - discountAmount + tax;

  // Calculate totals
  const calculateSubTotal1 = () => {
    return lineItems1.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal1 = calculateSubTotal1();
  const discountAmount1 = (subTotal1 * discount1) / 100;
  const finalTotal1 = subTotal1 - discountAmount1 + tax1;

  // Calculate totals
  const calculateSubTotal2 = () => {
    return lineItems2.reduce((sum, item) => {
      return sum + item.quantity * item.unitPrice;
    }, 0);
  };

  const subTotal2 = calculateSubTotal2();
  const discountAmount2 = (subTotal2 * discount2) / 100;
  const finalTotal2 = subTotal2 - discountAmount2 + tax2;

  // Add new line item
  const addLineItem = () => {
    const newId = Math.max(...lineItems.map((item) => item.id), 0) + 1;
    setLineItems([
      ...lineItems,
      {
        id: newId,
        product: "",
        description: "",
        quantity: 1,
        price: 0,
        unitPrice: 0,
      },
    ]);
  };

  // Add new line item
  const addLineItem1 = () => {
    const newId = Math.max(...lineItems1.map((item) => item.id), 0) + 1;
    setLineItems1([
      ...lineItems1,
      {
        id: newId,
        product: "",
        description: "",
        quantity: 1,
        price: 0,
        unitPrice: 0,
      },
    ]);
  };

  // Add new line item
  const addLineItem2 = () => {
    const newId = Math.max(...lineItems2.map((item) => item.id), 0) + 1;
    setLineItems2([
      ...lineItems2,
      {
        id: newId,
        product: "",
        description: "",
        quantity: 1,
        price: 0,
        unitPrice: 0,
      },
    ]);
  };

  // Delete line item
  const deleteLineItem = (id) => {
    setLineItems(lineItems.filter((item) => item.id !== id));
  };

  const deleteLineItem1 = (id) => {
    setLineItems1(lineItems1.filter((item) => item.id !== id));
  };

  const deleteLineItem2 = (id) => {
    setLineItems2(lineItems2.filter((item) => item.id !== id));
  };
  const updateLineItem = (id, field, value) => {
    // //console.log("updateLineItem calling", id, field, value);
    // //console.log("Previous lineItems", lineItems);
    let internalLineItems = [...lineItems];
    let getIndex = internalLineItems.findIndex((item) => item.id == id);
    ////console.log("getIndex", getIndex);
    if (getIndex !== -1) {
      internalLineItems[getIndex] = {
        ...internalLineItems[getIndex],
        [field]:
          field !== "product" && field !== "description"
            ? parseFloat(value) || 0
            : value,
      };

      internalLineItems[getIndex].price = parseFloat(
        internalLineItems[getIndex].quantity *
        internalLineItems[getIndex].unitPrice
      );
      //console.log("Updated internalLineItems", internalLineItems);
      setLineItems(internalLineItems);
    }
  };

  const updateLineItem1 = (id, field, value) => {
    let internalLineItems1 = [...lineItems1];
    let getIndex = internalLineItems1.findIndex((item) => item.id == id);
    if (getIndex !== -1) {
      internalLineItems1[getIndex] = {
        ...internalLineItems1[getIndex],
        [field]:
          field !== "product" && field !== "description"
            ? parseFloat(value) || 0
            : value,
      };
      internalLineItems1[getIndex].price = parseFloat(
        internalLineItems1[getIndex].quantity *
        internalLineItems1[getIndex].unitPrice
      );
      //console.log("Updated internalLineItems1", internalLineItems1);
      setLineItems1(internalLineItems1);
    }
  };

  const updateLineItem2 = (id, field, value) => {
    let internalLineItems2 = [...lineItems2];
    let getIndex = internalLineItems2.findIndex((item) => item.id == id);
    if (getIndex !== -1) {
      internalLineItems2[getIndex] = {
        ...internalLineItems2[getIndex],
        [field]:
          field !== "product" && field !== "description"
            ? parseFloat(value) || 0
            : value,
      };
      internalLineItems2[getIndex].price = parseFloat(
        internalLineItems2[getIndex].quantity *
        internalLineItems2[getIndex].unitPrice
      );

      setLineItems2(internalLineItems2);
    }
  };

  // Handle file selection
  const handleFileUpload = (event) => {
    //console.log("handleFileUpload calling");
    const files = Array.from(event.target.files);
    setUploadedFiles([...uploadedFiles, ...files]);
  };

  const handleRemoveFile = (index) => {
    //console.log("handleRemoveFile calling", index);
    // setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
    setFinalMediaToSend(finalMediaToSend.filter((_, i) => i !== index));
  };

  // UseEffect to trigger upload when `file` changes
  useEffect(() => {
    if (uploadedFiles.length > 0) {
      //console.log("Uploading files...", uploadedFiles);
      uploadFile();
    }
  }, [uploadedFiles]);

  // Function to handle file upload
  const uploadFile = async () => {
    //console.log("upload file calling");
    if (uploadedFiles.length > 0) {
      const formData = new FormData();
      uploadedFiles.forEach((file) => {
        formData.append("myfile", file);
      });
      try {
        const response = await dispatch(hitUploadMedia(formData));
        if (response.payload.status === true) {
          showToast(response.payload.message, "success");
          const uploadedUrls = response.payload.data.map((item) => item.url);
          setFinalMediaToSend((prev) => [...prev, ...uploadedUrls]);
        } else {
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        console.error("File upload error:", error);
      }
    }
  };

  const handleOptOutClick = (checked) => {
    //console.log("handleOptOutClick calling", selectedIndex, checked);
    if (checked === true) {
      if (selectedIndex === 0) {
        setDeletedIndexes((prev) => [...prev, 1, 2]);
      } else if (selectedIndex === 1) {
        setDeletedIndexes((prev) => [...prev, 0, 2]);
      } else if (selectedIndex === 2) {
        setDeletedIndexes((prev) => [...prev, 0, 1]);
      }
    }
    // in case of false return back all three options
    else {
      setDeletedIndexes([]);
    }
  };

  const removeImage = (index) => {
    if (deletedIndexes.length == 2) {
      showToast("At least one type is required.", "error");
      return;
    } else {
      setDeletedIndexes((prev) => [...prev, index]);
      // Find next or previous selectable index
      let newSelected = null;
      // 1️⃣ Try to select the next available item
      for (let i = index + 1; i < images.length; i++) {
        if (!deletedIndexes.includes(i)) {
          newSelected = i;
          break;
        }
      }

      // 2️⃣ If no next item found, try previous ones
      if (newSelected === null) {
        for (let i = index - 1; i >= 0; i--) {
          if (!deletedIndexes.includes(i)) {
            newSelected = i;
            break;
          }
        }
      }

      // 3️⃣ Update selectedIndex
      if (newSelected !== null) {
        setSelectedIndex(newSelected);
      } else {
        setSelectedIndex(null); // nothing left
      }
    }
  };

  const handleUpdateBidWithDraft = () => {
    // Construct the bid data
    handleUpdateBid(1);
  };

  const handleUpdateBid = (isDraft = 0) => {
    //console.log("handleUpdateBid calling draft status:", isDraft);
    // Construct the bid data
    let allArrays = [];
    if (deletedIndexes.includes(1) && deletedIndexes.includes(2)) {
      allArrays.push(lineItems);
    } else if (deletedIndexes.includes(0) && deletedIndexes.includes(2)) {
      allArrays.push(lineItems1);
    } else if (deletedIndexes.includes(0) && deletedIndexes.includes(1)) {
      allArrays.push(lineItems2);
    } else if (deletedIndexes.includes(0)) {
      allArrays.push(lineItems);
      allArrays.push(lineItems1);
    } else if (deletedIndexes.includes(1)) {
      allArrays.push(lineItems);
      allArrays.push(lineItems2);
    } else if (deletedIndexes.includes(2)) {
      allArrays.push(lineItems);
      allArrays.push(lineItems1);
    } else {
      allArrays.push(lineItems);
      allArrays.push(lineItems1);
      allArrays.push(lineItems2);
    }
    // //console.log("All Arrays", allArrays);

    // Condition 1: At least one array has items
    const hasAtLeastOneArrayWithItems = allArrays.some((arr) => arr.length > 0);
    if (!hasAtLeastOneArrayWithItems) {
      showToast("At least one line item must have items.", "error");
      return;
    }

    // Condition 2: Each non-empty array has at least one valid item
    const allValid = allArrays.every((arr) => {
      if (arr.length === 0) return true; // Skip empty arrays

      setLoading(true);

      // Check if the array has at least one valid item
      return arr.some(
        (item) =>
          item.product.trim() !== "" &&
          item.description.trim() !== "" &&
          item.price > 0
      );
    });

    if (!allValid) {
      setLoading(false);
      showToast(
        "Each item must have at least one item with product, description, and price."
      );
      return;
    }
    let options = [];

    for (let i = 0; i < allArrays.length; i++) {
      if (allArrays[i] == lineItems) {
        options.push({
          items: lineItems,
          optionType: 1,
          subTotal: subTotal.toString(),
          discountAmount: discountAmount.toString(),
          taxAmount: tax.toString(),
          finalAmount: finalTotal.toString(),
          discountPercentage: discount,
          optionPrice: "",
        });
      } else if (allArrays[i] == lineItems1) {
        options.push({
          items: lineItems1,
          optionType: 2,
          subTotal: subTotal1.toString(),
          discountAmount: discountAmount1.toString(),
          taxAmount: tax1.toString(),
          finalAmount: finalTotal1.toString(),
          discountPercentage: discount1,
          optionPrice: "",
        });
      } else if (allArrays[i] == lineItems2) {
        options.push({
          items: lineItems2,
          optionType: 3,
          subTotal: subTotal2.toString(),
          discountAmount: discountAmount2.toString(),
          taxAmount: tax2.toString(),
          finalAmount: finalTotal2.toString(),
          discountPercentage: discount2,
          optionPrice: "",
        });
      }
    }

    const bidData = {
      bidUpdate: 1,
      bidId: jobData?.bidData?._id,
      jobId: jobData._id,
      isDraft: isDraft,
      options: options,
      message: customerMessage,
      media: finalMediaToSend,
      expireAt: bidExpiry,
      requiredDeposit: requiredDeposit.toString(),
      financing: financing.toString(),
      priceType: priceType === "guarantee" ? 1 : 2, // 1- guranntee, 2- estimate
    };

    dispatch(hitUpdateBidProfessionalApi(bidData)).then((response) => {
      setLoading(false);
      if (response.payload && response.payload.status) {
        if (isDraft === 1) {
          showToast("Bid updated as draft successfully!", "success");
          navigation("/professional/bids", {
            state: { bidType: isDraft === 1 ? "draft" : "submitted" },
          });
        } else {
          showToast("Bid updated successfully!", "success");
          navigation("/professional/bids", {
            state: { bidType: isDraft === 1 ? "draft" : "submitted" },
          });
        }
      }
    });
  };

  if (loading) {
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }
  return (
    <div className="project-details">
      {/* Header */}
      <div className="pd-header">
        <h3>
          <span className="highlight">Project Details</span> &gt; Update Bid for
          Job
          {` ${jobData ? jobData.jobId : ""}`}{" "}
        </h3>
      </div>

      <div className="pd-images">
        <label>
          Options{" "}
          <input
            type="checkbox"
            disabled={isDisabled}
            onChange={(e) => handleOptOutClick(e.target.checked)}
          />
          <span>Opt out</span>
        </label>
        <div className="image-grid">
          {!deletedIndexes.includes(0) && (
            <div
              //key={index}
              className={`image-item ${selectedIndex === 0 ? "selected" : ""}`}
              onClick={() => setSelectedIndex(0)}
            >
              <img src={images[0]} alt="project" />
              <span
                className="remove"
                onClick={(e) => {
                  e.stopPropagation(); // 👈 Prevent click from reaching parent
                  removeImage(0);
                }}
              >
                ×
              </span>
            </div>
          )}

          {!deletedIndexes.includes(1) && (
            <div
              // key={index}
              className={`image-item ${selectedIndex === 1 ? "selected" : ""}`}
              onClick={() => setSelectedIndex(1)}
            >
              <img src={images[1]} alt="project" />
              <span
                className="remove"
                onClick={(e) => {
                  e.stopPropagation(); // 👈 Prevent click from reaching parent
                  removeImage(1);
                }}
              >
                ×
              </span>
            </div>
          )}

          {!deletedIndexes.includes(2) && (
            <div
              // key={index}
              className={`image-item ${selectedIndex === 2 ? "selected" : ""}`}
              onClick={() => setSelectedIndex(2)}
            >
              <img src={images[2]} alt="project" />
              <span
                className="remove"
                onClick={(e) => {
                  e.stopPropagation(); // 👈 Prevent click from reaching parent
                  removeImage(2);
                }}
              >
                ×
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Option good */}
      {/* Line Items */}
      {selectedIndex === 0 && (
        <>
          <div className="pd-line-items">
            <h6>Products/service</h6>
            {lineItems.map((item, index) => (
              <div className="line-item" key={item.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Line Item {index + 1}</h5>
                  {index > 0 && (
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deleteLineItem(item.id)}
                    />
                  )}
                </div>

                <label>Product/service</label>
                <input
                  type="text"
                  value={item.product}
                  onChange={(e) =>
                    updateLineItem(item.id, "product", e.target.value)
                  }
                />

                <label>Description</label>
                <textarea
                  type="text"
                  value={item.description}
                  onChange={(e) =>
                    updateLineItem(item.id, "description", e.target.value)
                  }
                />

                <div className="line-pricing">
                  <div>
                    <label>Quantity</label>
                    <input
                      type="number"
                      value={item.quantity}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");

                        let price = parseFloat(value) || 0;

                        // Enforce max 50000
                        if (price > 200) price = 200;
                        updateLineItem(item.id, "quantity", price);
                      }}
                    />
                  </div>
                  <div>
                    <label>Unit Price</label>
                    <input
                      type="text"
                      value={`$ ${item.unitPrice}`}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");
                        let price = parseFloat(value) || 0;

                        // Enforce max 50000
                        if (price > 50000) price = 50000;
                        updateLineItem(item.id, "unitPrice", price);
                      }}
                    />
                  </div>
                  <div>
                    <label>Line Total</label>
                    <input
                      type="text"
                      value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="add-more-section">
            <button className="add-more-btn" onClick={addLineItem}>
              <span className="plus-icon">+</span> Add More
            </button>
          </div>
          <div className="pricing-summary">
            <h4>Pricing Summary</h4>

            <div className="summary-row">
              <span className="label">Sub Total:</span>
              <span className="value">${subTotal.toFixed(2)}</span>
            </div>

            <div className="summary-row discount-row">
              <span className="label">Discount (%):</span>
              <div className="discount-input-wrapper">
                <input
                  type="text"
                  value={discount}
                  onChange={(e) =>
                    setDiscount(Math.min(parseFloat(e.target.value) || 0, 100))
                  }
                  className="discount-input"
                  max="100"
                  min="0"
                />
                <span className="percent-symbol">%</span>
              </div>
              <span className="value discount-value">
                -${discountAmount.toFixed(2)}
              </span>
            </div>

            <div className="summary-row">
              <span className="label">Tax:</span>
              <span className="value">${tax.toFixed(2)}</span>
            </div>

            <div className="summary-row final-row">
              <span className="label">Final Total:</span>
              <span className="value final-value">
                ${finalTotal.toFixed(2)}
              </span>
            </div>
          </div>
        </>
      )}

      {/* Option Better */}
      {/* Line Items */}
      {selectedIndex === 1 && (
        <>
          <div className="pd-line-items">
            <h6>Products/service</h6>
            {lineItems1.map((item, index) => (
              <div className="line-item" key={item.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Line Item {index + 1}</h5>
                  {index > 0 && (
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deleteLineItem1(item.id)}
                    />
                  )}
                </div>

                <label>Product/service</label>
                <input
                  type="text"
                  value={item.product}
                  onChange={(e) =>
                    updateLineItem1(item.id, "product", e.target.value)
                  }
                />

                <label>Description</label>
                <textarea
                  type="text"
                  value={item.description}
                  onChange={(e) =>
                    updateLineItem1(item.id, "description", e.target.value)
                  }
                />

                <div className="line-pricing">
                  <div>
                    <label>Quantity</label>
                    <input
                      type="text"
                      value={item.quantity}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");

                        let price = parseFloat(value) || 0;

                        // Enforce max 50000
                        if (price > 200) price = 200;
                        updateLineItem1(item.id, "quantity", price);
                      }}
                    />
                  </div>
                  <div>
                    <label>Unit Price</label>
                    <input
                      type="text"
                      value={`$ ${item.unitPrice}`}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");

                        let price = parseFloat(value) || 0;

                        // Enforce max 50000
                        if (price > 50000) price = 50000;
                        updateLineItem1(item.id, "unitPrice", price);
                      }}
                    />
                  </div>
                  <div>
                    <label>Line Total</label>
                    <input
                      type="text"
                      value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="add-more-section">
            <button className="add-more-btn" onClick={addLineItem1}>
              <span className="plus-icon">+</span> Add More
            </button>
          </div>
          <div className="pricing-summary">
            <h4>Pricing Summary</h4>

            <div className="summary-row">
              <span className="label">Sub Total:</span>
              <span className="value">${subTotal1.toFixed(2)}</span>
            </div>

            <div className="summary-row discount-row">
              <span className="label">Discount (%):</span>
              <div className="discount-input-wrapper">
                <input
                  type="text"
                  value={discount1}
                  onChange={(e) =>
                    setDiscount1(Math.min(parseFloat(e.target.value) || 0, 100))
                  }
                  className="discount-input"
                  max="100"
                  min="0"
                />
                <span className="percent-symbol">%</span>
              </div>
              <span className="value discount-value">
                -${discountAmount1.toFixed(2)}
              </span>
            </div>

            <div className="summary-row">
              <span className="label">Tax:</span>
              <span className="value">${tax1.toFixed(2)}</span>
            </div>

            <div className="summary-row final-row">
              <span className="label">Final Total:</span>
              <span className="value final-value">
                ${finalTotal1.toFixed(2)}
              </span>
            </div>
          </div>
        </>
      )}

      {/* Option Best */}
      {/* Line Items */}
      {selectedIndex === 2 && (
        <>
          <div className="pd-line-items">
            <h6>Products/service</h6>
            {lineItems2.map((item, index) => (
              <div className="line-item" key={item.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Line Item {index + 1}</h5>
                  {index > 0 && (
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deleteLineItem2(item.id)}
                    />
                  )}
                </div>

                <label>Product/service</label>
                <input
                  type="text"
                  value={item.product}
                  onChange={(e) =>
                    updateLineItem2(item.id, "product", e.target.value)
                  }
                />

                <label>Description</label>
                <textarea
                  type="text"
                  value={item.description}
                  onChange={(e) =>
                    updateLineItem2(item.id, "description", e.target.value)
                  }
                />

                <div className="line-pricing">
                  <div>
                    <label>Quantity</label>
                    <input
                      type="text"
                      value={item.quantity}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");
                        let price = parseFloat(value) || 0;

                        // Enforce max 200
                        if (price > 200) price = 200;
                        updateLineItem2(item.id, "quantity", price);
                      }}
                    />
                  </div>
                  <div>
                    <label>Unit Price</label>
                    <input
                      type="text"
                      value={`$ ${item.unitPrice}`}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");

                        let price = parseFloat(value) || 0;

                        // Enforce max 50000
                        if (price > 50000) price = 50000;
                        updateLineItem2(item.id, "unitPrice", price);
                      }}
                    />
                  </div>
                  <div>
                    <label>Line Total</label>
                    <input
                      type="text"
                      value={`$${(item.quantity * item.unitPrice).toFixed(2)}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="add-more-section">
            <button className="add-more-btn" onClick={addLineItem2}>
              <span className="plus-icon">+</span> Add More
            </button>
          </div>
          <div className="pricing-summary">
            <h4>Pricing Summary</h4>

            <div className="summary-row">
              <span className="label">Sub Total:</span>
              <span className="value">${subTotal2.toFixed(2)}</span>
            </div>

            <div className="summary-row discount-row">
              <span className="label">Discount (%):</span>
              <div className="discount-input-wrapper">
                <input
                  type="text"
                  value={discount2}
                  onChange={(e) =>
                    setDiscount2(Math.min(parseFloat(e.target.value) || 0, 100))
                  }
                  className="discount-input"
                  max="100"
                  min="0"
                />
                <span className="percent-symbol">%</span>
              </div>
              <span className="value discount-value">
                -${discountAmount2.toFixed(2)}
              </span>
            </div>

            <div className="summary-row">
              <span className="label">Tax:</span>
              <span className="value">${tax2.toFixed(2)}</span>
            </div>

            <div className="summary-row final-row">
              <span className="label">Final Total:</span>
              <span className="value final-value">
                ${finalTotal2.toFixed(2)}
              </span>
            </div>
          </div>
        </>
      )}

      {/* Additional Details Section */}
      <div className="additional-details">
        <h4>Additional Details</h4>

        {/* Customer Message */}
        <div className="form-group">
          <label>Customer Message</label>
          <textarea
            className="customer-message"
            value={customerMessage}
            onChange={(e) => setCustomerMessage(e.target.value)}
            rows="4"
          />
        </div>

        {/* Required Deposit and Bid Expiry */}
        <div className="two-column">
          <div className="form-group">
            <label>Required Deposit</label>
            <input
              type="text"
              value={`$ ${requiredDeposit}`}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                setRequiredDeposit(parseInt(value) || 0);
              }}
            />
          </div>
          <div className="form-group">
            <label>Bid Expiry</label>
            <input
              type="text"
              value={bidExpiry}
              onChange={(e) => setBidExpiry(e.target.value)}
            />
          </div>
        </div>

        {/* Financing */}
        <div className="form-group">
          <label>Financing (optional)</label>
          <input
            type="text"
            value={`$${financing}/month`}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");
              setFinancing(parseInt(value) || 0);
            }}
          />
        </div>

        {/* Attachments */}
        <div className="form-group attachments">
          <label>Attachments</label>
          <p className="helper-text">
            Upload documents, images or PDFs to support your bid.
          </p>
          <div className="upload-area">
            <FaUpload className="upload-icon" />
            <p>Drop files here or click to upload</p>
            <input
              type="file"
              multiple
              onChange={handleFileUpload}
              style={{ display: "none" }}
              id="file-upload"
            />
            <button
              type="button"
              className="choose-files-btn"
              onClick={() => document.getElementById("file-upload").click()}
            >
              Choose Files
            </button>
          </div>

          {finalMediaToSend.length > 0 && (
            <div className="uploaded-files">
              {finalMediaToSend.map((file, index) => (
                <div className="file-preview" key={index}>
                  <img src={file} alt={file.name} className="file-thumb" />
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => handleRemoveFile(index)}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Price Type Selection */}
      <div className="price-type-selection">
        <h4>Select one of the following:</h4>

        <div className="radio-group">
          <label className="radio-option">
            <input
              type="radio"
              name="priceType"
              value="guaranteed"
              checked={priceType === "guaranteed"}
              onChange={(e) => setPriceType(e.target.value)}
            />
            <FiShield className="price-icon shield-icon" />
            <span>Guaranteed Price</span>
            <FaInfoCircle className="info-icon" />
          </label>

          <label className="radio-option">
            <input
              type="radio"
              name="priceType"
              value="estimated"
              checked={priceType === "estimated"}
              onChange={(e) => setPriceType(e.target.value)}
            />
            <FaCalculator className="price-icon calculator-icon" />
            <span>Estimated Price</span>
            <FaInfoCircle className="info-icon" />
          </label>
        </div>
      </div>

      {/* <div className="bid-container">
        <div className="boost-amount">
          <h2>Your Boost Amount</h2>
          <div className="rank-table">
            <table>
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Bid</th>
                  <th>Now</th>
                </tr>
              </thead>
              <tbody>
                {boostBidsData.length > 0 &&
                  boostBidsData.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <span className="rank-icon">
                          <FaStar className="rank-icon" />
                        </span>
                        {row.rank}
                      </td>
                      <td className="bid_style">{row.amount} Credits</td>
                      <td>
                        {row.createdAt !== 1 ? (
                          timeAgo(row.createdAt) || ""
                        ) : (
                          <button onClick={() => handleRemoveBoostBid(index)}>
                            X
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="your-bid">
          <h3>Your Bid</h3>
          {boostBidsData.length > 0 && (
            <p>
              Bid {boostBidsData[0].amount + 1} credits or higher to be ranked
              in 1st place.
            </p>
          )}
          {boostBidsData.length === 0 && (
            <p>Bid 1 credits or higher to be ranked in 1st place.</p>
          )}
          <div className="bid-controller">
            <button onClick={handleDecrease}>-</button>
            <span>{bid}</span>
            <button onClick={handleIncrease}>+</button>
          </div>
          <div className="boost-bid-container">
            <div className="boost-bid">
              <button className="boost-btn">
                <img src={BoostYourBid} alt="Boost Your Bid" />
              </button>
              <div>
                <span> Boost Your Bid</span>
                <p className="boost-description">
                  Stand out from the increase your chances of winning
                </p>
              </div>
            </div>
            <button className="boost-now-btn" onClick={() => handleBoostBid()}>
              <img src={boostBtn} alt="Boost" style={{ margin: '0 5px 1px 0' }} />
              Boost
            </button>
          </div>
        </div>

        <h4>Summary</h4>
        <div className="summary">
          <p>
            Bid to boost: <span>{boostBidPoints} credits</span>
          </p>
          <p>
            Required for proposal:{" "}
            <span>{jobData.isReadyToGo == 1 ? 10 : 5} credits</span>
          </p>
          <p className="total">
            Total:{" "}
            <span>
              {(jobData.isReadyToGo == 1 ? 10 : 5) + boostBidPoints} credits
            </span>
          </p>
        </div>


        <div className="credits-required">
          <div className="info">
            <ErrorOutlineOutlinedIcon className="info-icon" />
            <h6>Credits Required</h6>
          </div>
          <p>
            Credits Required: Submit this bid will use{" "}
            {(jobData.isReadyToGo == 1 ? 10 : 5) + boostBidPoints} credits from your
            account. You currently have {credits} credits
          </p>
        </div>
      </div> */}

      <div className="actionss">
        <div className="button-wrapper">
          {jobData?.bidData?.isDraft == 1 && (
            <button
              className="save-btn btn-color"
              onClick={() => handleUpdateBidWithDraft()}
            >
              Update as Draft
            </button>
          )}
          <button
            className="submit-btn btn-color"
            onClick={() => handleUpdateBid(0)}
          >
            Update Your Bid
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateBidView;
